import axios from 'axios'
// axios.defaults.withCredentials = false
//ajax的get数据请求
export const get = (url, params) => {
    return axios.get(url, {
        params
    })
}
//ajax的post数据请求
export const post = (url, params) => {
    return axios.post(url, params, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}